import React, { FC } from 'react';
import { ReactComponent as BackArrow } from '../../../icons/BackArrow.svg';
import classes from './BackButton.module.css';

interface Props {
  isSecondary?: boolean;
  text: string;
  onClick: () => void;
}

const CandidatesBackButton: FC<Props> = ({ isSecondary, text, onClick }) => {
  const color = isSecondary ? 'var(--primary-green)' : 'var(--brand-blue-100)';

  return (
    <button
      className={classes.topBarBackButton}
      data-testid="back-button"
      onClick={onClick}
      type="button"
      style={{
        color,
        border: `1px solid ${color}`,
      }}
    >
      <div>
        <BackArrow fill={color} />
      </div>
      <span>{text}</span>
    </button>
  );
};

CandidatesBackButton.defaultProps = {
  isSecondary: false,
};

export default CandidatesBackButton;
